// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"Jba-z"};